import { render, staticRenderFns } from "./ProductDetailsV3.vue?vue&type=template&id=2ed1e559&scoped=true"
import script from "./ProductDetailsV3.vue?vue&type=script&lang=js"
export * from "./ProductDetailsV3.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailsV3.vue?vue&type=style&index=0&id=2ed1e559&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed1e559",
  null
  
)

export default component.exports